import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "28.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row3: [
      "NRSC Manpower",
      "2.5",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "5.1",
      "37.9",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "29.0",
      "29.0",
      "29.0",
      "29.0",
      "29.0",
      "29.0",
      "29.0",
      "203.3",
    ],
    row5: [
      "Data Analysis",
      "2.0",
      "8.0",
      "8.0",
      "8.0",
      "4.0",
      "4.0",
      "4.0",
      "4.0",
      "42.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "100.0",
      "247.0",
      "0.0",
      "30.6",
      "30.6",
      "30.6",
      "30.6",
      "30.6",
      "500.0",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "1.0",
      "8.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row10: [
      "Sub - Total 1",
      "105.5",
      "294.1",
      "47.1",
      "77.7",
      "73.7",
      "73.7",
      "73.7",
      "73.7",
      "819.1",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "5.3",
      "14.7",
      "2.4",
      "3.9",
      "3.7",
      "3.7",
      "3.7",
      "3.7",
      "41.0",
    ],
    row12: [
      "Sub - Total 2",
      "110.8",
      "308.8",
      "49.4",
      "81.6",
      "77.4",
      "77.4",
      "77.4",
      "77.4",
      "860.1",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "5.5",
      "15.4",
      "2.5",
      "4.1",
      "3.9",
      "3.9",
      "3.9",
      "3.9",
      "43.0",
    ],
    row14: [
      "Grand Total",
      "116.3",
      "324.2",
      "51.9",
      "85.6",
      "81.2",
      "81.2",
      "81.2",
      "81.2",
      "903.1",
    ],
  },
};
export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Operational Hydrological Drought Services using Remote Sensing
                  data
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Operational Hydrological Drought Services using Remote Sensing
                  data
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
